import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ScrollAreaDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../types";
import {
    getFocusRingStyle
} from "../../helpers/theme/state";
import {
    webStyle
} from "../../utils";

const stylesheet = StyleSheet.create({
    viewport: {
        flexShrink: 1,
        minHeight: 0,
        flexGrow: 1,
        minWidth: 0,
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    bothContent: {
        alignSelf: "flex-start",
        minWidth: "100%"
    },
    bothViewport: {
        ...webStyle({
            overflowX: "auto",
            overflowY: "auto"
        })
    },
    focusRing: {
        pointerEvents: "none",
        position: "absolute",
        bottom: 0,
        start: 0,
        top: 0,
        end: 0
    },
    container: {
        position: "relative",
        overflow: "hidden",
        flexShrink: 1
    },
    horizontalFade: {
        bottom: 0,
        top: 0
    },
    verticalFade: {
        start: 0,
        end: 0
    }
});

export const useStyles = ({
    isFocusVisible,
    radiusStyle,
    borders,
    colors,
    spaces
}: ScrollAreaDynamicStyleType) => {
    const styles = {
        verticalFade: {
            height: spaces.spacingMd
        } as Mutable<ViewStyle>,
        horizontalFade: {
            width: spaces.spacingMd
        } as Mutable<ViewStyle>,
        focusRing: {
            ...radiusStyle,
            ...getFocusRingStyle({
                isFocusVisible,
                isInset: true,
                borders,
                colors
            })
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
